import Icon from '../../../../primitives/icon/index';

export const WrappedIcon = ({
  containerClassName = '',
  dimensionString = '16',
  hideIcon = false,
  iconClassName = '',
  iconString,
}: {
  containerClassName?: string;
  dimensionString?: string;
  hideIcon?: boolean;
  iconClassName?: string;
  iconString: string;
}) => {
  if (hideIcon) return null;

  const [icon, dimension = dimensionString] = iconString.split(',');

  return (
    <div className={containerClassName}>
      <Icon className={iconClassName} height={parseInt(dimension, 10)} icon={icon} width={parseInt(dimension, 10)} />
    </div>
  );
};
